import React from 'react';
import { Card, Row, Col } from 'reactstrap';
import AAutoComplete from '../../../common/form-fields-mui/AAutoComplete';
import AButton from '../../../common/form-fields-mui/AButton';
import { statusDropdown } from './utils';
import CommonInput from '../../../common/formFeilds/input/commonInput';
import CustomDatePicker from '../../../common/commonComponents/CustomDatePicker';
import moment from 'moment';
import {selectStyles} from '../../qrCode/AddQrModal';
import { labelStyles } from './utils';

var _ = require('lodash');

const FilterForm = ({
    businessAreaDropdown,
    applyFilterHandler,
    form,
    handleFilterForm,
    closePopup,
    removeFilterHandler,
    filterCount
}) => {


    return (
        <Card style={{ width: '350px' }} className='mb-0 p-3'>
            <div className='d-flex justify-content-between'>
                <h4>Filter</h4>
            </div>
            <Row>
                <Col md={"12"}>
                <div style={labelStyles}>BusinessArea</div>
                    <AAutoComplete
                        // label='Business Area'
                        currentValue={form?.businessArea}
                        items={businessAreaDropdown}
                        handleChange={val => handleFilterForm(val, 'businessArea')}
                        isShowCount={true}
                        style={selectStyles}
                    />
                </Col>
                <Col md={'12'}>
                <div style={labelStyles}>Status</div>
                    <AAutoComplete
                        // label='Status'
                        items={statusDropdown}
                        currentValue={form?.status}
                        isMulti={false}
                        handleChange={val => handleFilterForm(val, 'status')}
                        style={selectStyles}
                    />
                </Col>
                <Col md={'12'}>
                    <div style={labelStyles}>Receipting Date from</div>
                    <CustomDatePicker
                        placeHolder="From"
                        maxDate={moment(new Date())}
                        value={
                            form?.receiptingDateFrom ? moment(form?.receiptingDateFrom) : null
                        }
                        handler={(index, date, keyName) => {
                            handleFilterForm(moment(date).startOf('day'), "receiptingDateFrom")
                        }}
                    />
                </Col>
                <Col md={'12'}>
                    <div style={labelStyles}>Receipting Date to</div>
                    <CustomDatePicker
                        placeHolder="To"
                        maxDate={moment(new Date())}
                        minDate={moment(form?.receiptingDateFrom)}
                        value={
                            form?.receiptingDateTo ? moment(form?.receiptingDateTo) : null
                        }
                        handler={(index, date, keyName) => {
                            handleFilterForm(moment(date).endOf('day'), "receiptingDateTo");
                        }}
                    />
                </Col>

            </Row>
            <div className='d-flex justify-content-between mt-2'>
                <AButton
                    variant='danger_filled'
                    onClick={() => { removeFilterHandler(); closePopup(); }}
                    size='xs'
                    className='no-ml-btn'
                    disabled={!form?.appliedFilterCount}
                >
                    Remove
                </AButton>

                <AButton
                    variant='primary_filled'
                    onClick={() => {
                        applyFilterHandler();
                        closePopup();
                    }}
                    size='xs'
                    disabled={filterCount === 0}
                >
                    Apply
                </AButton>
            </div>
        </Card>
    );
}

export default FilterForm;